<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" fill="none">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M8.308 2.176A6.925 6.925 0 0 0 2.11 8.373H0v1.384h2.111a6.925 6.925 0 0 0 6.197 6.197v2.11h1.384v-2.11a6.925 6.925 0 0 0 6.197-6.197H18V8.373h-2.111a6.925 6.925 0 0 0-6.197-6.197V.065H8.308v2.111ZM3.462 9.065a5.538 5.538 0 1 1 11.076 0 5.538 5.538 0 0 1-11.076 0Z"
      clip-rule="evenodd"
    />
    <path
      fill="currentColor"
      d="M10.846 9.125a1.846 1.846 0 1 1-3.692 0 1.846 1.846 0 0 1 3.692 0Z"
    />
  </svg>
</template>

<script setup lang="ts"></script>
